module.exports = __webpack_public_path__ + "static/img/logo.03dea459.png";